import { render, staticRenderFns } from "./VVDTextarea.vue?vue&type=template&id=2b568bfe&scoped=true"
import script from "./VVDTextarea.vue?vue&type=script&lang=js"
export * from "./VVDTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b568bfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b568bfe')) {
      api.createRecord('2b568bfe', component.options)
    } else {
      api.reload('2b568bfe', component.options)
    }
    module.hot.accept("./VVDTextarea.vue?vue&type=template&id=2b568bfe&scoped=true", function () {
      api.rerender('2b568bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VVDTextarea.vue"
export default component.exports